/* CatSketch card behavior (2026-06-15 r17, additive, no redesign).
   r16: preload-all + advance-to-ready (fixes frozen slideshow on heavy PNG / no-video categories). r15: room->flat per row — slideshow interleaves each row's ROOM then its FLAT
   (data-clawdbot-rooms + data-clawdbot-flats); starts on the room. Flats-only fallback.
   HOVER (after dwell) -> slideshow flats (480px, just-in-time loaded, decode-gated).
   MOUSE-OFF -> restore the cover image immediately, then (if the category has one)
   play its video twice. Up to 3 videos at once. Overlays created lazily.
   r14: `live` gate blocks stray interval/load callbacks from re-showing the flat after mouse-off. r13: flat overlay is a DIV w/ background-image (dodges Dawn '.media>img{opacity:1!important}' that pinned the <img> visible). r12: overlay opacity set with inline !important (theme CSS !important was forcing the <img> overlay visible -> non-video 'slideshow' cards got stuck on last flat). r11: (a) backToCover() force-restores the card's original cover image (fixes
   cards that didn't return to the first image when another script swapped it);
   (b) flats load just-in-time (first 2 now, rest prefetched 2 ahead) so the first
   frame paints fast even for heavy PNG categories like cathedral. */
(function () {
  if (window.__catsketchCardVideoBehavior20260613) return;
  window.__catsketchCardVideoBehavior20260613 = true;

  var FLAT_CYCLE_MS = 450, VIDEO_PLAYS = 2, ENTER_DWELL = 100, FLAT_W = 480, MAX_VIDEOS = 3;
  var PLAYING = 0;
  var REDUCE = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  function sized(u){ if (!u) return u; return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + FLAT_W; }
  function videoMap(){ return window.CATSKETCH_CATEGORY_HOVER_VIDEO_URLS || {}; }
  function handleFromCard(card){
    var h = card.getAttribute("data-clawdbot-product-handle");
    if (h) return h;
    var link = (card.matches && card.matches('a[href*="/products/"]')) ? card : card.querySelector('a[href*="/products/"]');
    if (!link) return "";
    var m = String(link.getAttribute("href") || "").match(/\/products\/([^/?#]+)/);
    return m ? m[1] : "";
  }
  function flatsForCard(card){
    var raw = card.getAttribute("data-clawdbot-flats");
    if (raw){ try { var a = JSON.parse(raw); if (a && a.length) return a; } catch(e){} }
    return [];
  }
  function roomsForCard(card){
    var raw = card.getAttribute("data-clawdbot-rooms");
    if (raw){ try { var a = JSON.parse(raw); if (a && a.length) return a; } catch(e){} }
    return [];
  }
  function videoForCard(card){
    var u = videoMap()[handleFromCard(card)];
    if (!u) return "";
    try { return new URL(u, location.href).href; } catch(e){ return u; }
  }
  function mediaHost(card){
    return card.querySelector(".card__media .media")
        || card.querySelector(".card__media")
        || card.querySelector(".card__inner") || card;
  }

  function bindCard(card){
    if (!card || card.__csCardVideoBound) return;
    var flats = flatsForCard(card).map(sized);
    var rooms = roomsForCard(card).map(sized);
    /* room->flat per row: start on the room, then its flat, for each row of the
       category. Falls back to flats-only for categories with no room_map yet. */
    var seq;
    if (rooms.length && rooms.length === flats.length){
      seq = []; for (var _q = 0; _q < flats.length; _q++){ seq.push(rooms[_q]); seq.push(flats[_q]); }
    } else { seq = flats; }
    var videoUrl = videoForCard(card);
    if (!seq.length && !videoUrl) return;
    card.__csCardVideoBound = true;
    var host = mediaHost(card);
    if (host.__csControlled) return; host.__csControlled = true;

    /* capture the original cover image(s) so we can always restore them */
    var baseState = [].slice.call(host.querySelectorAll("img")).map(function(im){
      return { im: im, src: im.getAttribute("src"), srcset: im.getAttribute("srcset") };
    });
    function restoreBase(){
      for (var i = 0; i < baseState.length; i++){ var b = baseState[i];
        if (b.src != null && b.im.getAttribute("src") !== b.src) b.im.setAttribute("src", b.src);
        if (b.srcset != null && b.im.getAttribute("srcset") !== b.srcset) b.im.setAttribute("srcset", b.srcset);
      }
    }

    var flatEl = null, vidEl = null, imgs = [];
    var slideTimer = null, enterTimer = null, idx = 0, plays = 0, mode = "idle", engaged = false, counted = false, live = false;

    function prepHost(){ var cs = getComputedStyle(host); if (cs.position === "static") host.style.position = "relative"; if (cs.overflow === "visible") host.style.overflow = "hidden"; }
    var OVCSS = "position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:0;transition:opacity .12s ease;pointer-events:none;display:block;";
    function ensureFlat(){
      if (flatEl) return flatEl; prepHost();
      flatEl = document.createElement("div"); flatEl.className = "cs-ov-flat";
      flatEl.setAttribute("aria-hidden","true");
      flatEl.style.cssText = "position:absolute;inset:0;width:100%;height:100%;background-size:cover;background-position:center;background-repeat:no-repeat;opacity:0;transition:opacity .12s ease;pointer-events:none;display:block;z-index:1200;"; flatEl.style.setProperty("opacity","0","important"); host.appendChild(flatEl); return flatEl;
    }
    function ensureVid(){
      if (vidEl) return vidEl; prepHost();
      vidEl = document.createElement("video"); vidEl.className = "cs-ov-vid";
      vidEl.muted = true; vidEl.playsInline = true; vidEl.preload = "none"; vidEl.loop = false;
      vidEl.setAttribute("muted",""); vidEl.setAttribute("playsinline",""); vidEl.setAttribute("aria-hidden","true");
      vidEl.style.cssText = OVCSS + "z-index:1300;background:#0a0a0a;"; vidEl.style.setProperty("opacity","0","important");
      vidEl.addEventListener("ended", function(){
        if (mode !== "video") return;
        plays++;
        if (plays < VIDEO_PLAYS){ try { vidEl.currentTime = 0; } catch(e){} vidEl.play(); }
        else backToCover();
      });
      host.appendChild(vidEl); return vidEl;
    }
    function clearSlide(){ if (slideTimer){ clearInterval(slideTimer); slideTimer = null; } }
    function setFlat(on){ if (!flatEl) return; if (on && !live) return; flatEl.style.setProperty("opacity", on ? "1" : "0", "important"); }
    function setVid(on){ if (vidEl) vidEl.style.setProperty("opacity", on ? "1" : "0", "important"); }
    function release(){ if (counted){ PLAYING--; counted = false; } }
    function stopVideo(){ if (vidEl){ try { vidEl.pause(); } catch(e){} setVid(false); } release(); }
    function ld(i){ if (imgs[i]) return imgs[i]; var im = new Image(); im.decoding = "async"; im.src = seq[i]; imgs[i] = im; return im; }

    function backToCover(){ live = false; mode = "idle"; engaged = false; clearSlide(); stopVideo(); setFlat(false); restoreBase(); }

    function showReady(i){
      var im = ld(i);
      if (im.complete && im.naturalWidth > 0){ flatEl.style.backgroundImage = 'url("' + seq[i] + '")'; setFlat(true); }
      else { im.addEventListener("load", function(){ if (mode === "flats" && idx === i){ flatEl.style.backgroundImage = 'url("' + seq[i] + '")'; setFlat(true); } }, { once: true }); }
    }
    function nextReady(from){
      for (var s = 1; s <= seq.length; s++){ var i = (from + s) % seq.length; var im = imgs[i]; if (im && im.complete && im.naturalWidth > 0) return i; }
      return -1;
    }
    function startSlideshow(){
      engaged = true; live = true; mode = "flats"; stopVideo();
      if (!seq.length){ return; }
      ensureFlat();
      /* r17 perf: load only a small rolling window (current + next 2) instead of the
         WHOLE set in parallel. r16 decoded up to ~20 images per hover (room+flat seq),
         which saturated decode/bandwidth and made the slideshow stutter (and video
         cards worse). The decode-gate (nextReady) already prevents showing an
         undecoded frame, so a small window cannot reintroduce the r16 freeze. */
      var LOOKAHEAD = 2;
      ld(0); for (var k = 1; k <= LOOKAHEAD && k < seq.length; k++) ld(k);
      idx = 0; showReady(0);
      clearSlide();
      if (REDUCE) return;   /* reduced-motion: show one flat, skip the slideshow */
      slideTimer = setInterval(function(){
        var n = nextReady(idx);                      /* advance to the next DECODED frame; never freeze waiting on a single slow image */
        if (n >= 0){ idx = n; flatEl.style.backgroundImage = 'url("' + seq[idx] + '")'; setFlat(true); }
        ld((idx + LOOKAHEAD + 1) % seq.length);      /* prefetch just ahead of playback (rolling window) */
      }, FLAT_CYCLE_MS);
    }
    function playVideoTwice(){
      if (!videoUrl || REDUCE){ backToCover(); return; }
      if (!counted && PLAYING >= MAX_VIDEOS){ backToCover(); return; }
      if (!counted){ PLAYING++; counted = true; }
      mode = "video"; clearSlide(); setFlat(false);
      ensureVid();
      if (!vidEl.src){ vidEl.src = videoUrl; }
      plays = 0; setVid(true);
      try { vidEl.currentTime = 0; } catch(e){}
      var p = vidEl.play(); if (p && p.catch) p.catch(function(){ backToCover(); });
    }

    function enter(){
      if (mode === "video"){ backToCover(); }
      if (enterTimer) clearTimeout(enterTimer);
      enterTimer = setTimeout(function(){ enterTimer = null; startSlideshow(); }, ENTER_DWELL);
    }
    function leave(){
      live = false;
      if (enterTimer){ clearTimeout(enterTimer); enterTimer = null; }
      clearSlide(); setFlat(false); restoreBase(); mode = "idle";
      if (!engaged){ return; }
      engaged = false;
      playVideoTwice();
    }
    card.addEventListener("pointerenter", enter);
    card.addEventListener("pointerleave", leave);
    card.addEventListener("mouseenter", function(){ if (!window.PointerEvent) enter(); });
    card.addEventListener("mouseleave", function(){ if (!window.PointerEvent) leave(); });
  }

  function bindAll(){
    var cards = document.querySelectorAll(".card-wrapper");
    if (!cards.length) cards = document.querySelectorAll(".product-card");
    for (var i = 0; i < cards.length; i++) bindCard(cards[i]);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bindAll, { once: true });
  else bindAll();
  if (window.MutationObserver){
    var t = null;
    new MutationObserver(function(){ if (t) return; t = setTimeout(function(){ t = null; bindAll(); }, 400); })
      .observe(document.getElementById("product-grid") || document.querySelector(".collection, #MainContent, main") || document.body, { childList: true, subtree: true });
  }
})();
